module.exports = __webpack_public_path__ + "media/images/banner-page-bg-24d9ed3257f285978fc9ef7b11e9e5c8.webp";